import {
  slab, wallZ, goal, sign, neon, checkpoint, edgeLights, ring,
} from '../kit.js';

const terrace = (x, y, z, w = 28, d = 24) => [
  slab(x, y, z, w, d, 'plate', 1.4),
  ...edgeLights(x, y, z, w, d, 'lime'),
];

/**
 * Boost rings. Each hop is a leap of faith off a terrace edge with a ring
 * hanging just past it; the ring throws you at the next terrace, and the
 * chain teaches that leaving the ground IS the route. The finale converts a
 * drop through the classic floor-to-wall fling and sails the canyon.
 */
export default {
  id: 'cascade',
  name: 'CASCADE',
  blurb: 'The rings know the way. Jump.',
  mode: { type: 'sprint', par: 45 },
  redline: { seconds: 41 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 6], yaw: 0 },
  killY: -150,
  env: {
    fog: 0x061c14,
    fogDensity: 0.0040,
    sky: { zenith: 0x02100a, horizon: 0x0a2e1c, glow: 0x18b06a, aurora: 0x2ff3a8 },
    floorY: -300,
  },
  objects: [
    // ---- start terrace
    ...terrace(0, 0, 0, 26, 26),
    checkpoint(0, 0, 6),
    sign(0, 3.2, 5, 0, ['CASCADE', 'JUMP INTO THE RINGS', 'THEY THROW YOU ONWARD'], '#2ff3a8'),

    // ---- the hops. Each ring hangs two metres past the terrace edge AT
    // DECK HEIGHT: a plain walk off the edge falls into it and gets thrown.
    // No jump timing, no aim; commitment is the only input.
    ring(0, 0.4, -15, [0, 0.42, -0.91], 22),
    ...terrace(0, -8, -48),
    checkpoint(0, -8, -44),

    ring(0, -7.6, -62, [0, 0.42, -0.91], 22),
    ...terrace(0, -16, -96),
    checkpoint(0, -16, -92),

    ring(0, -15.6, -110, [0, 0.42, -0.91], 22),
    ...terrace(0, -22, -154, 32, 36),
    checkpoint(0, -22, -160),
    sign(0, -18.8, -161, 0, ['THE PIT TAKES A PORTAL', 'THE TALL WALL FACES THE END'], '#ffb020'),

    // ---- finale: pit tucked under the terrace lip, exit wall aimed down
    // the canyon. 48m of fall comes out of the wall at ~46 m/s.
    wallZ(0, -70, -165.25, 24, 48, 'plate', 1.5),
    wallZ(0, -70, -189.75, 24, 36, 'plate', 1.5),    // stops short; the fling clears it
    slab(0, -70, -177, 22, 23, 'panel', 1.5),        // portalable pit floor
    neon(0, -69.4, -177, [20, 0.16, 0.16], 'magenta'),

    // the exit wall stands on the terrace, facing the goal bay
    wallZ(0, -22, -150.5, 26, 12, 'panel', 1.4),
    neon(0, -9.6, -151.2, [26, 0.16, 0.16], 'lime'),

    // ---- goal bay, enormous and forgiving. Starts at -217: a lazy fling
    // off the lip exits at ~39 m/s and lands ~-221; the bay must catch it.
    slab(0, -46, -272, 60, 110, 'plate', 2),
    ...edgeLights(0, -46, -272, 60, 110, 'cyan'),
    wallZ(0, -46, -327.5, 62, 24, 'plate', 2),
    checkpoint(0, -46, -236),
    goal(0, -46, -294, 0),
  ],
};
